import * as React from "react";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { useState, useEffect, useCallback } from "react";
import { ChartHeader } from "components/Dashboard";
import creditorsIcon from "../../assets/DashboardIcons/Creditor.svg";
import { useDashboardData } from "services/dashboardService";

export const CreditorsChart = (props) => {
  const [type, setType] = useState("Month");
  const [filters, setFilters] = useState({});
  const [series, setSeries] = useState([]);

  const { data: dashboardData, loading } = useDashboardData();
  const creditorsData = dashboardData?.creditors;

  const [typesData, setTypesData] = useState([]);

  useEffect(() => {
    if (creditorsData?.data) {
      const pieChartData = creditorsData.data.map((item) => ({
        key: item.key,
        amount: item.amount,
      }));
      setSeries(pieChartData);
    } else {
      setSeries([]);
    }
  }, [creditorsData?.data]);

  useEffect(() => {
    if (props.filters) {
      setFilters(props.filters);
    }
  }, [props.filters]);

  useEffect(() => {
    typesUpdater();
  }, [filters, type]);

  const typesUpdater = useCallback(() => {
    let types = [];
    if (filters?.feeEarnerRef === null) {
      types.push({
        label: "By Fee Earner",
        value: "FeeEarner",
      });
    }
    if (filters?.appCode === null) {
      types.push({
        label: "By App",
        value: "Application",
      });
    }
    if (filters?.branch === null) {
      types.push({
        label: "By Branch",
        value: "Branch",
      });
    }
    if (filters?.month === null) {
      types.push({
        label: "By Month",
        value: "Month",
      });
    }
    setTypesData(types);

    let check = false;
    types.forEach((item) => {
      if (item.value === type) {
        check = true;
      }
    });
    if (!check) {
      setType("Month");
    }
  }, [filters, type]);

  const chartDefaultV4Colors = [
    "#241CCA",
    "#27E7AC",
    "#00A8E1",
    "#F1F0FF",
    "#96A0FF",
    "#aa46be",
  ];

  return (
    <div className="h-100 p-2">
      <ChartHeader
        name={"Creditors"}
        type={"(Actual vs Targets)"}
        icon={creditorsIcon}
        color={"#F5F5F5"}
        duration={filters?.duration}
        iconWidth={26}
        iconHeight={26}
      />
      <div className="h-100 p-2">
        {loading ? (
          <div className="h-100 p-2 d-flex align-items-center justify-content-center">
            <div className="text-muted">Loading creditors data...</div>
          </div>
        ) : (
          <Chart
            style={{
              height: 225,
            }}
            seriesColors={chartDefaultV4Colors}
          >
            <ChartSeries>
              <ChartSeriesItem
                type="pie"
                overlay={{
                  gradient: "sharpBevel",
                }}
                tooltip={{
                  visible: true,
                }}
                data={series}
                categoryField="key"
                field="amount"
              />
            </ChartSeries>
          </Chart>
        )}
      </div>
    </div>
  );
};
